import { Component, OnInit, Input } from '@angular/core';
import { Customer } from '@app/shared/customer';

@Component({
  selector: 'app-customer-summary',
  templateUrl: './customer-summary.component.html',
  styleUrls: ['./customer-summary.component.scss']
})
export class CustomerSummaryComponent {
  @Input() customer: Customer;
}
